export default {
  loginUser: ({ commit }, payload) => {
    commit('LOGIN_USER', payload)
  }
}
